import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';
let httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', }), responseType: 'text' as 'json' };

const apiUrl = environment.API_URL;

@Injectable({ providedIn: 'root' })

export class APIService {

    private userSubject: BehaviorSubject<any>;
    public user: Observable<any>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.userSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('user')));
        this.user = this.userSubject.asObservable();
    }

    public get userValue(): any {
        return this.userSubject.value;
    }

    login(body: any) {
        return this.http.post<any>(`${apiUrl}/auth/adminlogin`, body);
    }

    logout() {
        localStorage.removeItem('user');
        this.userSubject.next(null);
        this.router.navigate(['/pages/login']);
    }

    register(user: any) {
        const headers: HttpHeaders = getHeaders();
        // Agregar rol student por defecto para registro de estudiantes
        const userData = {
            ...user,
            role: 'student'
        };
        console.log('📤 [API] Enviando registro con rol student:', userData);
        return this.http.post<any>(`${apiUrl}/auth/signup`, userData, { headers });
    }

    forgotPassword(body: any) {
        return this.http.post<any>(`${apiUrl}/auth/reset`, body, httpOptions);
    }

    changePassword(body: { email: string; password: string }) {
        const headers: HttpHeaders = getHeaders();
        return this.http.post<any>(`${apiUrl}/auth/change-password`, body, { headers });
    }

    getAll() {

        const headers: HttpHeaders = getHeaders();
        return this.http.get<any[]>(`${apiUrl}/users`, { headers });
    }

    getActiveUsers() {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any[]>(`${apiUrl}/users-active`, { headers });
    }

    adminCreateUser(user: { firstName: string; lastName: string; email: string; roles: string }): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        const body = { ...user, profiles: ['user', 'business', 'ambassador'] };
        return this.http.post<any>(`${apiUrl}/auth/signup`, body, { headers });
    }

    getUsersQuery(params: { q?: string; role?: string; active?: string; limit?: number; offset?: number }): Observable<{ Count: number; Pages: number; List: any[] }> {
        const headers: HttpHeaders = getHeaders();
        const query = new URLSearchParams();
        if (params.q)      query.set('q',      params.q);
        if (params.role)   query.set('role',   params.role);
        if (params.active !== undefined && params.active !== '') query.set('active', params.active);
        query.set('limit',  String(params.limit  ?? 20));
        query.set('offset', String(params.offset ?? 0));
        return this.http.get<{ Count: number; Pages: number; List: any[] }>(`${apiUrl}/users-query?${query.toString()}`, { headers });
    }

    getById(id: string) {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${apiUrl}/user/${id}`, { headers });
    }

    /**
     * Obtiene el perfil del usuario autenticado usando la nueva API auth/profile
     * Esta API devuelve los datos del usuario incluyendo la URL de la foto de perfil
     * @returns Observable con los datos del perfil del usuario
     */
    getProfile(): Observable<any> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<any>(`${apiUrl}/auth/profile`, { headers });
    }

    // ── Perfil profesional extendido ─────────────────────────────────────────

    /**
     * GET /api/profile-extra/:userId
     * Retorna { profileExtra: { bannerUrl, category, education[], experience[], projects[] } | null }
     */
    getProfileExtra(userId: number): Observable<{ profileExtra: any }> {
        const headers: HttpHeaders = getHeaders();
        return this.http.get<{ profileExtra: any }>(`${apiUrl}/profile-extra/${userId}`, { headers });
    }

    /**
     * PUT /api/profile-extra/:userId
     * Body: { bannerUrl?, category?, education?, experience?, projects? }
     */
    updateProfileExtra(userId: number, data: {
        bannerUrl?: string;
        category?: string;
        education?: any[];
        experience?: any[];
        projects?: any[];
    }): Observable<{ success: boolean; profileExtra: any }> {
        const headers: HttpHeaders = getHeaders();
        return this.http.put<{ success: boolean; profileExtra: any }>(
            `${apiUrl}/profile-extra/${userId}`, data, { headers }
        );
    }

    //
    /* updateResource(data: any){
         const token =
         localStorage.getItem('token');
     }
 
     const Headers = new HttpHeaders({'Authorization': 'Bearer ${token}'
 
     });
 ***/


    update(id, params) {
        return this.http.put(`/users/${id}`, params)
            .pipe(map(x => {
                if (id == this.userValue) {
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    this.userSubject.next(user);
                }
                return x;
            }));

        //  return this.http.put(this.apiUrl, data, {Headers});
    }
}

